import { IClaimInsertionForm } from "../models/models";
import * as yup from "yup";

export const PRIORITY_LIST = [
    {
        code: 'LOW',
        description: "Low",
        label: "Low"
    },
    {
        code: 'MEDIUM',
        description: "Medium",
        label: "Medium"
    },
    {
        code: 'HIGH',
        description: "High",
        label: "High"
    }
];

export const CLAIM_TYPES = [
    {
        code: 'ACCESSORI',
        description: "Accessori",
        label: "Accessori"
    },
    {
        code: 'AMAZON',
        description: "Amazon",
        label: "Amazon"
    },
    {
        code: 'CANCEL_FLEX_PRE_PAID',
        description: "Cancel Flex Pre-Paid",
        label: "High"
    }
];

export const BY_LEGAL_RAPRESENTATIVE_LIST = [
    {
        code: 'NO',
        description: "No",
        label: "No"
    },
    {
        code: 'YES',
        description: "Yes",
        label: "Yes"
    }
];

export const REQUISTER_TYPE_LIST = [
    {
        code: 'CLIENT',
        description: "Client",
        label: "Client"
    },
    {
        code: 'HUSBAND',
        description: "Husband",
        label: "Husband"
    },
    {
        code: 'WIFE',
        description: "Wife",
        label: "Wife"
    },
    {
        code: 'SON_DAUGHTER',
        description: "Son/Daughter",
        label: "Son/Daughter"
    },
    {
        code: 'EMPLOYEE',
        description: "Employee",
        label: "Employee"
    }
];

export const CLAIM_INSERTION_INITIAL_VALUE_FORM: IClaimInsertionForm = {
    claimInsertionRaInfo: {
        raNumber: '',
        dmsIdentificationCode: null,
        pickUpDate: null,
        renewalsAndSubstitutions: '',
        invoiceNumber: '',
        invoiceDMSIdentificationCode: '',
        invoiceDate: null,
        segment: '',
        category: '',
        product: '',
        customerCode: ''
    },
    claimInsertionInfo: {
        priority: null,
        type: null,
        claimNotes: '',
        byLegalRepresentative: BY_LEGAL_RAPRESENTATIVE_LIST[0],
        email: '',
        prefix: null,
        phone: '',
        requesterType: null,
        requesterNotes: '',
    },
    attachments: {
        files: []
    }
}

export const CLAIM_INSERTION_FORM_VALIDATION_SCHEMA = yup.object().shape({
    claimInsertionInfo: yup.object().shape({
        priority: yup.object()
            .nullable()
            .required("common.error.required"),
        type: yup.object()
            .nullable()
            .required("common.error.required"),
        byLegalRepresentative: yup.object()
            .nullable()
            .required("common.error.required"),
        email: yup.string()
            .email('common.error.email.isNotValid')
            .required("common.error.required"),
        prefix: yup.object()
            .nullable()
            .required("common.error.required"),
        phone: yup.string()
            .required("common.error.required"),
        requesterType: yup.object()
            .nullable()
            .required("common.error.required")
    })
})